import { GET_EMAILJS_CONFIG } from "./apiEndpoints";

/**
 * Fetches the EmailJS configuration from the backend.
 *
 * @returns {Promise<Object>} A promise that resolves to the EmailJS configuration.
 * @throws {Error} If the fetch request fails.
 */
export const fetchEmailConfig = async () => {
  try {
    const response = await fetch(GET_EMAILJS_CONFIG);
    if (!response.ok) {
      throw new Error("Failed to fetch EmailJS configuration");
    }
    const data = await response.json();
    return {
      serviceId: data.serviceId,
      templateId: data.templateId,
      userId: data.userId,
    };
  } catch (error) {
    console.error("Failed to fetch EmailJS configuration:", error);
    throw error;
  }
};
